'use strict';

var _wrapNativeSuper = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _classCallCheck = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _toConsumableArray = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/helpers/toConsumableArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _require = require('./util'),
    format = _require.format,
    inspect = _require.inspect,
    CustomAggregateError = _require.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/master/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/


var AggregateError = globalThis.AggregateError || CustomAggregateError;
var kIsNodeError = Symbol('kIsNodeError');
var kTypes = ['string', 'function', 'number', 'object', // Accept 'Function' and 'Object' as alternative to the lower cased version.
'Function', 'Object', 'boolean', 'bigint', 'symbol'];
var classRegExp = /^([A-Z][a-z0-9]*)+$/;
var nodeInternalPrefix = '__node_internal_';
var codes = {};

function assert(value, message) {
  if (!value) {
    throw new codes.ERR_INTERNAL_ASSERTION(message);
  }
} // Only use this for integers! Decimal numbers do not work with this function.


function addNumericalSeparator(val) {
  var res = '';
  var i = val.length;
  var start = val[0] === '-' ? 1 : 0;

  for (; i >= start + 4; i -= 3) {
    res = "_".concat(val.slice(i - 3, i)).concat(res);
  }

  return "".concat(val.slice(0, i)).concat(res);
}

function getMessage(key, msg, args) {
  if (typeof msg === 'function') {
    assert(msg.length <= args.length, // Default options do not count.
    "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
    return msg.apply(void 0, _toConsumableArray(args));
  }

  var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
  assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));

  if (args.length === 0) {
    return msg;
  }

  return format.apply(void 0, [msg].concat(_toConsumableArray(args)));
}

function E(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  var NodeError = /*#__PURE__*/function (_Base) {
    _inherits(NodeError, _Base);

    var _super = _createSuper(NodeError);

    function NodeError() {
      _classCallCheck(this, NodeError);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _super.call(this, getMessage(code, message, args));
    }

    _createClass(NodeError, [{
      key: "toString",
      value: function toString() {
        return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
      }
    }]);

    return NodeError;
  }(Base);

  Object.defineProperties(NodeError.prototype, {
    name: {
      value: Base.name,
      writable: true,
      enumerable: false,
      configurable: true
    },
    toString: {
      value: function value() {
        return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
      },
      writable: true,
      enumerable: false,
      configurable: true
    }
  });
  NodeError.prototype.code = code;
  NodeError.prototype[kIsNodeError] = true;
  codes[code] = NodeError;
}

function hideStackFrames(fn) {
  // We rename the functions that will be hidden to cut off the stacktrace
  // at the outermost one
  var hidden = nodeInternalPrefix + fn.name;
  Object.defineProperty(fn, 'name', {
    value: hidden
  });
  return fn;
}

function aggregateTwoErrors(innerError, outerError) {
  if (innerError && outerError && innerError !== outerError) {
    if (Array.isArray(outerError.errors)) {
      // If `outerError` is already an `AggregateError`.
      outerError.errors.push(innerError);
      return outerError;
    }

    var err = new AggregateError([outerError, innerError], outerError.message);
    err.code = outerError.code;
    return err;
  }

  return innerError || outerError;
}

var AbortError = /*#__PURE__*/function (_Error) {
  _inherits(AbortError, _Error);

  var _super2 = _createSuper(AbortError);

  function AbortError() {
    var _this;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'The operation was aborted';
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    _classCallCheck(this, AbortError);

    if (options !== undefined && typeof options !== 'object') {
      throw new codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
    }

    _this = _super2.call(this, message, options);
    _this.code = 'ABORT_ERR';
    _this.name = 'AbortError';
    return _this;
  }

  return AbortError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

E('ERR_ASSERTION', '%s', Error);
E('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  assert(typeof name === 'string', "'name' must be a string");

  if (!Array.isArray(expected)) {
    expected = [expected];
  }

  var msg = 'The ';

  if (name.endsWith(' argument')) {
    // For cases like 'first argument'
    msg += "".concat(name, " ");
  } else {
    msg += "\"".concat(name, "\" ").concat(name.includes('.') ? 'property' : 'argument', " ");
  }

  msg += 'must be ';
  var types = [];
  var instances = [];
  var other = [];

  var _iterator = _createForOfIteratorHelper(expected),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var value = _step.value;
      assert(typeof value === 'string', 'All expected entries have to be of type string');

      if (kTypes.includes(value)) {
        types.push(value.toLowerCase());
      } else if (classRegExp.test(value)) {
        instances.push(value);
      } else {
        assert(value !== 'object', 'The value "object" should be written as "Object"');
        other.push(value);
      }
    } // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (instances.length > 0) {
    var pos = types.indexOf('object');

    if (pos !== -1) {
      types.splice(types, pos, 1);
      instances.push('Object');
    }
  }

  if (types.length > 0) {
    switch (types.length) {
      case 1:
        msg += "of type ".concat(types[0]);
        break;

      case 2:
        msg += "one of type ".concat(types[0], " or ").concat(types[1]);
        break;

      default:
        {
          var last = types.pop();
          msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
        }
    }

    if (instances.length > 0 || other.length > 0) {
      msg += ' or ';
    }
  }

  if (instances.length > 0) {
    switch (instances.length) {
      case 1:
        msg += "an instance of ".concat(instances[0]);
        break;

      case 2:
        msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
        break;

      default:
        {
          var _last = instances.pop();

          msg += "an instance of ".concat(instances.join(', '), ", or ").concat(_last);
        }
    }

    if (other.length > 0) {
      msg += ' or ';
    }
  }

  switch (other.length) {
    case 0:
      break;

    case 1:
      if (other[0].toLowerCase() !== other[0]) {
        msg += 'an ';
      }

      msg += "".concat(other[0]);
      break;

    case 2:
      msg += "one of ".concat(other[0], " or ").concat(other[1]);
      break;

    default:
      {
        var _last2 = other.pop();

        msg += "one of ".concat(other.join(', '), ", or ").concat(_last2);
      }
  }

  if (actual == null) {
    msg += ". Received ".concat(actual);
  } else if (typeof actual === 'function' && actual.name) {
    msg += ". Received function ".concat(actual.name);
  } else if (typeof actual === 'object') {
    var _actual$constructor;

    if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) {
      msg += ". Received an instance of ".concat(actual.constructor.name);
    } else {
      var inspected = inspect(actual, {
        depth: -1
      });
      msg += ". Received ".concat(inspected);
    }
  } else {
    var _inspected = inspect(actual, {
      colors: false
    });

    if (_inspected.length > 25) {
      _inspected = "".concat(_inspected.slice(0, 25), "...");
    }

    msg += ". Received type ".concat(typeof actual, " (").concat(_inspected, ")");
  }

  return msg;
}, TypeError);
E('ERR_INVALID_ARG_VALUE', function (name, value) {
  var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
  var inspected = inspect(value);

  if (inspected.length > 128) {
    inspected = inspected.slice(0, 128) + '...';
  }

  var type = name.includes('.') ? 'property' : 'argument';
  return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
E('ERR_INVALID_RETURN_VALUE', function (input, name, value) {
  var _value$constructor;

  var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value);
  return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);
E('ERR_MISSING_ARGS', function () {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  assert(args.length > 0, 'At least one arg needs to be specified');
  var msg;
  var len = args.length;
  args = (Array.isArray(args) ? args : [args]).map(function (a) {
    return "\"".concat(a, "\"");
  }).join(' or ');

  switch (len) {
    case 1:
      msg += "The ".concat(args[0], " argument");
      break;

    case 2:
      msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
      break;

    default:
      {
        var last = args.pop();
        msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
      }
      break;
  }

  return "".concat(msg, " must be specified");
}, TypeError);
E('ERR_OUT_OF_RANGE', function (str, range, input) {
  assert(range, 'Missing "range" argument');
  var received;

  if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) {
    received = addNumericalSeparator(String(input));
  } else if (typeof input === 'bigint') {
    received = String(input);

    if (input > Math.pow(2n, 32n) || input < -Math.pow(2n, 32n)) {
      received = addNumericalSeparator(received);
    }

    received += 'n';
  } else {
    received = inspect(input);
  }

  return "The value of \"".concat(str, "\" is out of range. It must be ").concat(range, ". Received ").concat(received);
}, RangeError);
E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
  AbortError: AbortError,
  aggregateTwoErrors: hideStackFrames(aggregateTwoErrors),
  hideStackFrames: hideStackFrames,
  codes: codes
};